import { State } from './free-to-play-duck';
import createSliceSelector from '../../utils/create-slice-selector';

const selectFreeToPlayState = createSliceSelector<State>('free-to-play');
export default selectFreeToPlayState;
